import { useModal, withModalConditionalRender } from '@billy/design-system'

import { useEmberCloseModal } from '../../../../../contexts/emberCloseModalContext'
import { ModalId } from '../../../../../enums/modalId'
import { useInvoice } from '../../../../invoices/hooks/useInvoice'
import { InvoiceReconciliationModal as InvoiceReconciliationModalComponent } from '../InvoiceReconciliationModal'

type InvoiceReconciliationModalWrapperProps = {
  invoiceId: string
}

const InvoiceReconciliationModal = withModalConditionalRender(InvoiceReconciliationModalComponent)

const InvoiceReconciliationModalWrapper = ({ invoiceId }: InvoiceReconciliationModalWrapperProps) => {
  const { data } = useInvoice(invoiceId)

  const { closeEmberModal } = useEmberCloseModal()

  useModal(ModalId.InvoiceReconciliationModal, {
    onClose: closeEmberModal,
  })

  return (
    data?.invoice && (
      <InvoiceReconciliationModal forceRender subject={data.invoice} id={ModalId.InvoiceReconciliationModal} />
    )
  )
}

export default InvoiceReconciliationModalWrapper
